import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { v4 as uuid4 } from "uuid";

import { environment } from '../../../../environments/environment';
import { Auction } from '../models/auction';
import { LoggingService } from '../../../services/logging.service';
import { AuctionDrugItem } from "../models/auction-drug-item";


const MODULE_PATH = "TakomaClient.src.app.modules.home.services"

const API_SERVER = environment.apiServer;


@Injectable()
export class AuctionDetailService {

  constructor(private _http: HttpClient, private _loggingService: LoggingService) { }

  // TODO: Типизировать модель `auctionDetail`
  // TODO: Добавить LoggingWrapper
  get(auctionNumber: string, callback: (auctionDetail) => void): void {
    const xid = uuid4();
    const qualName = "app.modules.home.services.AuctionDetailService.get";
    const inputParams = { "auctionNumber": auctionNumber, "callback": callback };
    const description = "[Reactive] Получение карточки аукциона из базы данных";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      this._http.get(`${API_SERVER}/auction/detail/${auctionNumber}`).subscribe(callback);

      this._loggingService.logFinish(xid, qualName, inputParams, description);
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description);
      throw error;
    }
  }

  getCalculatedHeader(auction: Auction): Observable<Auction> {
    const xid = this._loggingService.generateUUID();
    const qualName = 'App.Services.AuctionDetailService.getCalculatedHeader';
    const inputParams = { auction };
    const description = '[Reactive] Запуск расчетной шапки карточки аукциона из базы данных';

    this._loggingService.logStart(xid, qualName, inputParams, description);

    return this._http.put<Auction>(
      `${API_SERVER}/auction/detail-calc-header`,
      auction
    )
      .do(result => {
        this._loggingService.logFinish(xid, qualName, inputParams, description);
      })
      .catch(error => {
        this._loggingService.logError(xid, qualName, error, inputParams, description);
        return Observable.throw(error);
      });
  }

  public getDrug(numberAuction: string): Observable<any> {
    const xid = this._loggingService.generateUUID();
    const qualName = 'App.Services.AuctionDetailService.getDrug';
    
    this._loggingService.logStart(xid, qualName, null, 'Getting auction drugs');
    
    return this._http.get(`${API_SERVER}/auction/drug/${numberAuction}`)
      .do(result => {
        this._loggingService.logFinish(xid, qualName, null, 'Auction drugs retrieved');
      })
      .catch(error => {
        this._loggingService.logError(xid, qualName, error, null, 'Failed to get auction drugs');
        return Observable.throw(error);
      });
  }

  // TODO: Добавить LoggingWrapper
  saveAuction(auction: Auction) {
    const xid = uuid4();
    const qualName = `${MODULE_PATH}.AuctionDetailService.saveAuction`;
    const inputParams = { "auction": auction };
    const description = "[Reactive] Отправка запроса на сохранение карточки аукциона в API";

    try {
      this._loggingService.logStart(xid, qualName, inputParams, description);

      // TODO: Добавить LoggingWrapper для Observable
      let result = this._http.put<string>(`${API_SERVER}/auction/detail`, auction);

      this._loggingService.logFinish(xid, qualName, inputParams, description);

      return result;
    } catch (error) {
      this._loggingService.logError(xid, qualName, error, inputParams, description)
      throw error;
    }
  }

  public putLog(value: string) {
    const xid = this._loggingService.generateUUID();
    const qualName = 'App.Services.AuctionDetailService.putLog';
    
    this._loggingService.logStart(xid, qualName, null, 'Putting log');
    
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this._http.put<string>(`${API_SERVER}/auction/log`, JSON.stringify(value), httpOptions)
      .do(result => {
        this._loggingService.logFinish(xid, qualName, null, 'Log saved');
      })
      .catch(error => {
        this._loggingService.logError(xid, qualName, error, null, 'Failed to save log');
        return Observable.throw(error);
      });
  }


  calculateDrugsAuction(
    auction: Auction,
    distributorType: number | null,
    alterRow?: string
  ) {
    const payload = {
      auction: auction,
      distributorType: distributorType
    };
    return this._http.put<{ drugs: AuctionDrugItem[] }>(
      `${API_SERVER}/auction/detail/drugs`,
      payload
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/home/services/home-auction-detail.service.ts